import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin(() => {
	if (process.client) {
		const script = document.createElement('script');
		script.src = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU';
		script.type = 'text/javascript';
		script.async = true;
		document.head.appendChild(script);
	}
});
